<div class="container greyTextContainer">
  <h1>Service Agreement</h1>

  <br />
  <p>
    If you would like ADIEM to manage your NDIS plan and pay providers on your
    behalf, please fill out the following form and submit. On submission, a
    pre-populated service agreement will be sent to your email address for you
    to review. When you receive the email, you will see that the form has extra
    fields where you can provide extra information such as bank details and
    automatically approved providers for easy payment.
  </p>
  <p>All fields marked with an asterix * must be filled in.</p>
  <p>
    You can view our privacy policy
    <a class="link" routerLink="/privacy-policy"> here</a>.
  </p>
  <br />
  <!-- IE WARNING -->
  <div class="ie-notice">
    <p>
      PLEASE NOTE: Your web browser is out of date and this form may not work
      correctly. Please update your browser for more security, speed and the
      best experience on this site.
    </p>
    <a class="button" href="https://outdatedbrowser.com" target="_blank">Update your browser here</a>
  </div>
  <br />
  <form [formGroup]="serviceAgreement" class="serviceAgreement">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2>NDIS Plan Details <small>(Required)</small></h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- NDIS NUMBER -->
      <mat-form-field appearance="fill">
        <mat-label>NDIS No.</mat-label>
        <input #ndisNumber type="text" formControlName="ndisNumber" matInput placeholder="Enter your NDIS number"
          required />
        <mat-error *ngIf="f.ndisNumber.touched && f.ndisNumber.errors">
          <mat-error *ngIf="f.ndisNumber.errors.required">
            NDIS Number is required
          </mat-error>
          <mat-error *ngIf="f.ndisNumber.errors.wrongLength">
            NDIS Number should be 9 digits long with no spaces
          </mat-error>
          <mat-error *ngIf="
              f.ndisNumber.errors.notAllNumbers && !f.ndisNumber.errors.required
            ">
            NDIS Number should be digits only
          </mat-error>
          <mat-error *ngIf="f.ndisNumber.errors.not4or5">
            NDIS Number should begin with 4 or 5
          </mat-error>
          <mat-error *ngIf="f.ndisNumber.errors.numberExists">
            NDIS Number has already been used before
          </mat-error>
          <!-- <mat-error *ngIf="f.ndisNumber.errors.noMatch">
            The details provided don't match the NDIS file on record
          </mat-error> -->
          <mat-error *ngIf="f.ndisNumber.value && f.ndisNumber.errors.min">
            Not enough numbers
          </mat-error>
          <mat-error *ngIf="f.ndisNumber.value && f.ndisNumber.errors.max">
            Too many numbers
          </mat-error>
        </mat-error>
      </mat-form-field>

      <div class="singleRow">
        <!-- PLAN START DATE -->
        <mat-form-field appearance="fill">
          <mat-label>Plan Start Date:</mat-label>
          <input matInput [matDatepicker]="planStartDate" placeholder="DD/MM/YYYY" formControlName="planStartDate"
             />
          <mat-datepicker-toggle matSuffix [for]="planStartDate"></mat-datepicker-toggle>
          <mat-datepicker #planStartDate [calendarHeaderComponent]="calendarHeader"></mat-datepicker>
          <!-- <mat-error *ngIf="f.planStartDate.touched && f.planStartDate.errors">
            <mat-error *ngIf="f.planStartDate.errors.required">
              Start date is required
            </mat-error> 
          </mat-error> -->
        </mat-form-field>

        <!-- PLAN END DATE -->
        <mat-form-field appearance="fill">
          <mat-label>Plan End Date:</mat-label>
          <input matInput [matDatepicker]="planEndDate" placeholder="DD/MM/YYYY" formControlName="planEndDate"
             />
          <mat-datepicker-toggle matSuffix [for]="planEndDate"></mat-datepicker-toggle>
          <mat-datepicker #planEndDate [calendarHeaderComponent]="calendarHeader"></mat-datepicker>
          <!-- <mat-error *ngIf="f.planEndDate.touched && f.planEndDate.errors">
            <mat-error *ngIf="f.planEndDate.errors.required">
              End date is required
            </mat-error>
          </mat-error> -->
        </mat-form-field>
      </div>
      <br />
    </mat-expansion-panel>
    <br />
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2>Participant's Details <small>(Required)</small></h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="singleRow">
        <!-- PARTICIPANT FIRST NAME -->
        <mat-form-field appearance="fill">
          <mat-label>First Name</mat-label>
          <input #participantFirstName type="text" formControlName="participantFirstName" required matInput
            placeholder="Enter your first name" />
          <mat-error *ngIf="
              f.participantFirstName.touched && f.participantFirstName.errors
            ">
            <mat-error *ngIf="f.participantFirstName.errors.required">
              First name is required
            </mat-error>
            <mat-error *ngIf="f.participantFirstName.errors.notAllLetters">
              Only letters & hyphens accepted
            </mat-error>
            <!-- <mat-error *ngIf="f.participantFirstName.errors.noMatch">
              The details provided don't match the NDIS file on record
            </mat-error> -->
          </mat-error>
        </mat-form-field>

        <!-- PARTICIPANT LAST NAME -->
        <mat-form-field appearance="fill">
          <mat-label>Last Name</mat-label>
          <input #participantLastName type="text" formControlName="participantLastName" required matInput
            placeholder="Enter your last name" />
          <mat-error *ngIf="
              f.participantLastName.touched && f.participantLastName.errors
            ">
            <mat-error *ngIf="f.participantLastName.errors.required">
              Last name is required
            </mat-error>
            <mat-error *ngIf="f.participantLastName.errors.notAllLetters">
              Only letters & hyphens accepted
            </mat-error>
            <!-- <mat-error *ngIf="f.participantLastName.errors.noMatch">
              The details provided doesn't match the NDIS file on record
            </mat-error> -->
          </mat-error>
        </mat-form-field>

        <!-- PARTICIPANT D.O.B. -->
        <mat-form-field appearance="fill">
          <mat-label>Date of Birth:</mat-label>
          <input matInput required [matDatepicker]="participantDOB" placeholder="DD/MM/YYYY"
            formControlName="participantDOB" />
          <mat-datepicker-toggle matSuffix [for]="participantDOB"></mat-datepicker-toggle>
          <mat-datepicker #participantDOB></mat-datepicker>
          <mat-error *ngIf="f.participantDOB.touched && f.participantDOB.errors">
            <mat-error *ngIf="f.participantDOB.errors.required">
              Date of Birth is required
            </mat-error>
            <!-- <mat-error *ngIf="f.participantDOB.errors.noMatch">
              The details provided doesn't match the NDIS file on record
            </mat-error> -->
          </mat-error>
        </mat-form-field>
      </div>

      <div class="singleRow">
        <!-- PARTICIPANT'S PHONE -->
        <mat-form-field appearance="fill">
          <mat-label>Phone No.</mat-label>
          <input #participantPhone type="text" formControlName="participantPhone" matInput
            placeholder="Enter preferred phone number" />
          <mat-error *ngIf="f.participantPhone.touched && f.participantPhone.errors">
            <mat-error *ngIf="f.participantPhone.errors.wrongFormat">
              Phone must be numbers only in Australian format
            </mat-error>
            <mat-error *ngIf="f.participantPhone.errors.min">
              Not enough numbers
            </mat-error>
            <mat-error *ngIf="f.participantPhone.errors.max">
              Too many numbers
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- PARTICIPANT'S EMAIL -->
        <mat-form-field appearance="fill">
          <mat-label>Email Address</mat-label>
          <input #participantEmail type="email" formControlName="participantEmail" matInput
            [required]="f.participantStatements.value" placeholder="Enter email address"  />
          <mat-error *ngIf="f.participantEmail.touched && f.participantEmail.errors">
            <mat-error *ngIf="f.participantEmail.errors.required">
              Email is required
            </mat-error>
            <mat-error *ngIf="
                f.participantEmail.errors && !f.participantEmail.errors.required
              ">
              Email isn't in the correct format
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- PARTICIPANT'S STREET -->
      <mat-form-field appearance="fill">
        <mat-label>Street</mat-label>
        <input #participantStreet formControlName="participantStreet" type="text" matInput ngx-gp-autocomplete
          placeholder="Street address" [options]="addressOptions"
          (onAddressChange)="fillParticipantAddressFields($event)" />
        <mat-error *ngIf="f.participantStreet.touched && f.participantStreet.errors">
          <mat-error *ngIf="f.participantStreet.errors.notAlphaNumeric">
            Street can only be letters, numbers, forward-slashes & hyphens only
          </mat-error>
        </mat-error>
      </mat-form-field>

      <div class="singleRow">
        <!-- PARTICIPANT'S SUBURB  -->
        <mat-form-field appearance="fill">
          <mat-label>Suburb</mat-label>
          <input #participantCity type="text" formControlName="participantCity" matInput placeholder="Suburb" />
          <mat-error *ngIf="f.participantCity.touched && f.participantCity.errors">
            <mat-error *ngIf="
                f.participantCity.touched &&
                f.participantCity.errors.notAllLetters
              ">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- PARTICIPANT'S POSTCODE  -->
        <mat-form-field appearance="fill">
          <mat-label>Postcode</mat-label>
          <input #participantPostcode type="text" formControlName="participantPostcode" matInput
            placeholder="Postcode" />
          <mat-error *ngIf="
              f.participantPostcode.touched && f.participantPostcode.errors
            ">
            <mat-error *ngIf="f.participantPostcode.errors.notAllNumbers">
              Numbers only
            </mat-error>
            <mat-error *ngIf="
                f.participantPostcode.value && f.participantPostcode.errors.min
              ">
              Not enough numbers
            </mat-error>
            <mat-error *ngIf="
                f.participantPostcode.value && f.participantPostcode.errors.max
              ">
              Too many numbers
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- PARTICIPANT'S STATE  -->
        <mat-form-field appearance="fill">
          <mat-label>State</mat-label>
          <input #participantState type="text" formControlName="participantState" matInput placeholder="State" />
          <mat-error *ngIf="f.participantState.touched && f.participantState.errors">
            <mat-error *ngIf="
                f.participantState.touched &&
                f.participantState.errors.notAllLetters
              ">
              Only letters accepted
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- PARTICIPANT'S RECEIVE STATEMENTS -->
      <mat-checkbox #participantStatements formControlName="participantStatements" type="checkbox" color="primary"
        class="checkbox">Participant to Receive Statements
      </mat-checkbox>
      <br />
    </mat-expansion-panel>
    <br />
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2>Nominee Details <small>(Optional)</small></h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="singleRow">
        <!-- NOMINEE FIRST NAME -->
        <mat-form-field appearance="fill">
          <mat-label>First Name</mat-label>
          <input #nomineeFirstName type="text" formControlName="nomineeFirstName" matInput
            placeholder="Enter first name" />
          <mat-error *ngIf="f.nomineeFirstName.touched && f.nomineeFirstName.errors">
            <mat-error *ngIf="f.nomineeFirstName.errors.notAllLetters">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- NOMINEE LAST NAME -->
        <mat-form-field appearance="fill">
          <mat-label>Last Name</mat-label>
          <input #nomineeLastName type="text" formControlName="nomineeLastName" matInput
            placeholder="Enter last name" />
          <mat-error *ngIf="f.nomineeLastName.touched && f.nomineeLastName.errors">
            <mat-error *ngIf="f.nomineeLastName.errors.notAllLetters">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="singleRow">
        <!-- NOMINEE'S PHONE -->
        <mat-form-field appearance="fill">
          <mat-label>Phone No.</mat-label>
          <input #nomineePhone type="text" formControlName="nomineePhone" matInput
            placeholder="Enter preferred phone number" />
          <mat-error *ngIf="f.nomineePhone.touched && f.nomineePhone.errors">
            <mat-error *ngIf="f.nomineePhone.errors.wrongFormat">
              Phone must be numbers only in Australian format
            </mat-error>
            <mat-error *ngIf="f.nomineePhone.errors.min">
              Not enough numbers
            </mat-error>
            <mat-error *ngIf="f.nomineePhone.errors.max">
              Too many numbers
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- NOMINEE'S EMAIL -->
        <mat-form-field appearance="fill">
          <mat-label>Email Address</mat-label>
          <input #nomineeEmail type="email" formControlName="nomineeEmail" matInput placeholder="Enter email address"
            [required]="f.nomineeStatements.value"  />
          <mat-error *ngIf="f.nomineeEmail.touched && f.nomineeEmail.errors">
            <mat-error *ngIf="f.nomineeEmail.errors.required">
              Email is required
            </mat-error>
            <mat-error *ngIf="f.nomineeEmail.errors && !f.nomineeEmail.errors.required">
              Email isn't in the correct format
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- NOMINEE'S STREET -->
      <mat-form-field appearance="fill">
        <mat-label>Street Address</mat-label>
        <input #nomineeStreet type="text" formControlName="nomineeStreet" matInput placeholder="Street address"
          [options]="addressOptions" ngx-gp-autocomplete (onAddressChange)="fillNomineeAddressFields($event)" />
        <mat-error *ngIf="f.nomineeStreet.touched && f.nomineeStreet.errors">
          <mat-error *ngIf="f.nomineeStreet.errors.notAlphaNumeric">
            Street can only be letters, numbers, forward-slashes & hyphens only
          </mat-error>
        </mat-error>
      </mat-form-field>

      <div class="singleRow">
        <!-- NOMINEE'S SUBURB  -->
        <mat-form-field appearance="fill">
          <mat-label>Suburb</mat-label>
          <input #nomineeCity type="text" formControlName="nomineeCity" matInput placeholder="Suburb" />
          <mat-error *ngIf="f.nomineeCity.touched && f.nomineeCity.errors">
            <mat-error *ngIf="
                f.nomineeCity.touched && f.nomineeCity.errors.notAllLetters
              ">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- NOMINEE'S POSTCODE  -->
        <mat-form-field appearance="fill">
          <mat-label>Postcode</mat-label>
          <input #nomineePostcode type="text" formControlName="nomineePostcode" matInput placeholder="Postcode" />
          <mat-error *ngIf="f.nomineePostcode.touched && f.nomineePostcode.errors">
            <mat-error *ngIf="f.nomineePostcode.errors.notAllNumbers">
              Numbers only
            </mat-error>
            <mat-error *ngIf="f.nomineePostcode.value && f.nomineePostcode.errors.min">
              Not enough numbers
            </mat-error>
            <mat-error *ngIf="f.nomineePostcode.value && f.nomineePostcode.errors.max">
              Too many numbers
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- NOMINEE'S STATE  -->
        <mat-form-field appearance="fill">
          <mat-label>State</mat-label>
          <input #nomineeState type="text" formControlName="nomineeState" matInput placeholder="State" />
          <mat-error *ngIf="f.nomineeState.touched && f.nomineeState.errors">
            <mat-error *ngIf="
                f.nomineeState.touched && f.nomineeState.errors.notAllLetters
              ">
              Only letters accepted
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>
      <!-- NOMINEE'S RECEIVE STATEMENTS -->
      <mat-checkbox #nomineeStatements formControlName="nomineeStatements" type="checkbox" class="checkbox"
        color="primary">Nominee to Receive Statements
      </mat-checkbox>
      <br />
    </mat-expansion-panel>

    <br />
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2>Support Coordinator Details <small>(Optional)</small></h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="singleRow">
        <!-- SUPPORT COORDINATOR'S FIRST NAME -->
        <mat-form-field appearance="fill">
          <mat-label>First Name</mat-label>
          <input #supportCoFirstName type="text" formControlName="supportCoFirstName" matInput
            placeholder="Enter first name" />
          <mat-error *ngIf="f.supportCoFirstName.touched && f.supportCoFirstName.errors">
            <mat-error *ngIf="f.supportCoFirstName.errors.notAllLetters">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- SUPPORT COORDINATOR'S LAST NAME -->
        <mat-form-field appearance="fill">
          <mat-label>Last Name</mat-label>
          <input #supportCoLastName type="text" formControlName="supportCoLastName" matInput
            placeholder="Enter last name" />
          <mat-error *ngIf="f.supportCoLastName.touched && f.supportCoLastName.errors">
            <mat-error *ngIf="f.supportCoLastName.errors.notAllLetters">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="singleRow">
        <!-- SUPPORT COORDINATOR'S PHONE -->
        <mat-form-field appearance="fill">
          <mat-label>Phone No.</mat-label>
          <input #supportCoPhone type="text" formControlName="supportCoPhone" matInput
            placeholder="Enter phone number" />
          <mat-error *ngIf="f.supportCoPhone.touched && f.supportCoPhone.errors">
            <mat-error *ngIf="f.supportCoPhone.errors.wrongFormat">
              Phone must be numbers only in Australian format
            </mat-error>
            <mat-error *ngIf="f.supportCoPhone.errors.min">
              Not enough numbers
            </mat-error>
            <mat-error *ngIf="f.supportCoPhone.errors.max">
              Too many numbers
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- SUPPORT COORDINATOR'S EMAIL -->
        <mat-form-field appearance="fill">
          <mat-label>Email Address</mat-label>
          <input #supportCoEmail type="email" formControlName="supportCoEmail" matInput
            placeholder="Enter email address" [required]="f.supportCoStatements.value" />
          <mat-error *ngIf="f.supportCoEmail.touched && f.supportCoEmail.errors">
            <mat-error *ngIf="f.supportCoEmail.errors.required">
              Email is required
            </mat-error>
            <mat-error *ngIf="
                f.supportCoEmail.errors && !f.supportCoEmail.errors.required
              ">
              Email isn't in the correct format
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>

      <!-- SUPPORT COORDINATOR'S STREET -->
      <mat-form-field appearance="fill">
        <mat-label>Street Address</mat-label>
        <input #supportCoStreet type="text" formControlName="supportCoStreet" matInput placeholder="Street address"
          [options]="addressOptions" ngx-gp-autocomplete (onAddressChange)="fillSupportCoAddressFields($event)" />
        <mat-error *ngIf="f.supportCoStreet.touched && f.supportCoStreet.errors">
          <mat-error *ngIf="f.supportCoStreet.errors.notAlphaNumeric">
            Street can only be letters, numbers, forward-slashes & hyphens only
          </mat-error>
        </mat-error>
      </mat-form-field>

      <div class="singleRow">
        <!-- SUPPORT COORDINATOR'S SUBURB  -->
        <mat-form-field appearance="fill">
          <mat-label>Suburb</mat-label>
          <input #supportCoCity type="text" formControlName="supportCoCity" matInput placeholder="Suburb" />
          <mat-error *ngIf="f.supportCoCity.touched && f.supportCoCity.errors">
            <mat-error *ngIf="
                f.supportCoCity.touched && f.supportCoCity.errors.notAllLetters
              ">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- SUPPORT COORDINATOR'S POSTCODE  -->
        <mat-form-field appearance="fill">
          <mat-label>Postcode</mat-label>
          <input #supportCoPostcode type="text" formControlName="supportCoPostcode" matInput placeholder="Postcode" />
          <mat-error *ngIf="f.supportCoPostcode.touched && f.supportCoPostcode.errors">
            <mat-error *ngIf="f.supportCoPostcode.errors.notAllNumbers">
              Numbers only
            </mat-error>
            <mat-error *ngIf="
                f.supportCoPostcode.value && f.supportCoPostcode.errors.min
              ">
              Not enough numbers
            </mat-error>
            <mat-error *ngIf="
                f.supportCoPostcode.value && f.supportCoPostcode.errors.max
              ">
              Too many numbers
            </mat-error>
          </mat-error>
        </mat-form-field>

        <!-- SUPPORT COORDINATOR'S STATE  -->
        <mat-form-field appearance="fill">
          <mat-label>State</mat-label>
          <input #supportCoState type="text" formControlName="supportCoState" matInput placeholder="State" />
          <mat-error *ngIf="f.supportCoState.touched && f.supportCoState.errors">
            <mat-error *ngIf="
                f.supportCoState.touched &&
                f.supportCoState.errors.notAllLetters
              ">
              Only letters accepted
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>
      <!-- SUPPORT COORDINATOR'S RECEIVE STATEMENTS -->
      <mat-checkbox #supportCoStatements formControlName="supportCoStatements" type="checkbox" class="checkbox"
        color="primary">Support Coordinator to Receive Statements
      </mat-checkbox>
      <br />
    </mat-expansion-panel>
    <br />
    <!-- SERVICE AGREEMENT SECTION -->
    <div class="formContainer">
      <h2 class="title">Service Agreement Details</h2>
      <p class="saDetails">
        Enter the details for who will be signing the service agreement, their
        relationship to the participant if they are not the participant and the
        email address for the delivery of the service agreement.
      </p>
      <div class="singleRow">
        <!-- SERVICE AGREEMENT SIGNER -->
        <mat-form-field appearance="fill">
          <mat-label>Signatory</mat-label>
          <input #servAgreeSignatory type="text" formControlName="servAgreeSignatory" required matInput
            placeholder="Enter Participant Name or Trusted Person" />
          <mat-error *ngIf="f.servAgreeSignatory.touched && f.servAgreeSignatory.errors">
            <mat-error *ngIf="f.servAgreeSignatory.errors.required">
              Please enter the service agreement signer's full name:
            </mat-error>
            <mat-error *ngIf="
                f.servAgreeSignatory.touched &&
                f.servAgreeSignatory.errors.notAllLetters
              ">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>
        <!-- SERVICE AGREEMENT RELATIONSHIP -->
        <mat-form-field appearance="fill">
          <mat-label>Relationship</mat-label>
          <input #servAgreeRelationship type="text" formControlName="servAgreeRelationship"
            matInput placeholder="Enter relationship to the participant" />
          <mat-error *ngIf="
              f.servAgreeRelationship.touched && f.servAgreeRelationship.errors
            ">
            <mat-error *ngIf="f.servAgreeRelationship.errors.required">
              Please enter relationship to the participant
            </mat-error>
            <mat-error *ngIf="
                f.servAgreeRelationship.touched &&
                f.servAgreeRelationship.errors.notAllLetters
              ">
              Only letters & hyphens accepted
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>
      <!-- SERVICE AGREEMENT EMAIL ADDRESS -->
      <mat-form-field appearance="fill">
        <mat-label>Email address</mat-label>
        <input #servAgreeEmail type="email" formControlName="servAgreeEmail" required matInput
          placeholder="Enter email address for delivery of Service Agreement" />
        <mat-error *ngIf="f.servAgreeEmail.touched && f.servAgreeEmail.errors">
          <mat-error *ngIf="f.servAgreeEmail.errors.required">
            Please enter an email address for delivery of service agreement:
          </mat-error>
          <mat-error *ngIf="f.servAgreeEmail.errors && !f.servAgreeEmail.errors.required">
            Email isn't in the correct format
          </mat-error>
        </mat-error>
      </mat-form-field>

      <div class="centreButton">
        <button class="submitBtn" [class.formInvalidBtn]="serviceAgreement.invalid" mat-raised-button type="button"
          color="primary" (click)="submitForm()">
          <span [class.formInvalidBtn]="serviceAgreement.invalid" *ngIf="!submitted">Send Service Agreement</span>
          <!-- Animated Circle Submission Confirmation -->
          <div [ngClass]="{
              'circle-loader': submitted,
              'load-complete': delivered
            }">
            <div class="checkmark draw" [ngStyle]="{ display: delivered ? 'block' : 'none' }"></div>
          </div>
        </button>
      </div>

      <br />
    </div>
  </form>
</div>